<template>
  <div class="single-column-content pa-5 ma-3">
    <page-title :title="$t('auth.forgot.page_title')"></page-title>
    <h1 class="title mb-5" v-html="$t('auth.forgot.section_title')"></h1>
    <form v-if="!hideForm" action="/reset-password" @submit.prevent="submit" class="login-form">
      <v-layout column>
        <v-flex class="text-input-container">
          <label> {{ $t('email') }} </label>
          <v-text-field
            class="lg-text-field"
            v-model="formData.username"
            autocomplete="email"
            solo
            v-validate="'required|email|max:50'"
            :error-messages="errors.collect('email')"
            data-vv-name="email"
            required
            counter="50"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row justify-center class="mb-3">
        <v-btn
          color="primary"
          type="submit"
          depressed
          round
          large
          :loading="submitLoading"
          >{{ $t('submit') }}</v-btn
        >
      </v-layout>
    </form>
      <h3 class="ma-3 text-md-center" v-if="hideForm">
          We have sent and email to {{formData.username}}. Please check the inbox and follow the instructions.
      </h3>
    <v-layout justify-center class="signup-bottom-bar">
      {{ $t('auth.login.dont_have_account') }}
      <router-link class="link ml-2" to="signup">{{
        $t('auth.signup.page_title')
      }}</router-link>
    </v-layout>
  </div>
</template>

<script>
import formMixins from '@/mixins/forms'
import userApi from '@/api/user'
export default {
  name: 'Login',
  mixins: [formMixins],
  created: function() {},
  data: function() {
    return {
      formData: {
        username: ''
      },
      hideForm: false
    }
  },
  computed: {},
  methods: {
    submit: function() {
      const vm = this
      if (!this.isFormValid) return
      userApi.resetPasswordRequest(vm.formData).then(function(res) {
        if (res.data.errors.length === 0) {
          vm.hideForm = true
        } else {
          vm.hideForm = false
          vm.addFormError(
            'email',
            "We couldn't reset the password. Please check the email you entered."
          )
        }
      })
    }
  }
}
</script>

<style lang="stylus">
@require "common.styl"
    .single-column-content {
        width 500px
    }
</style>
